import {
  fetchPublicSession,
  hasAuthenticatedPublicSession,
  type PublicSession,
} from '@/lib/public-session';

type WaitForAuthenticatedSessionOptions = {
  getSessionFn?: () => Promise<PublicSession | null>;
  timeoutMs?: number;
  intervalMs?: number;
};

export async function waitForAuthenticatedSession(
  options: WaitForAuthenticatedSessionOptions = {},
): Promise<PublicSession> {
  const getSessionFn = options.getSessionFn ?? fetchPublicSession;
  const timeoutMs = options.timeoutMs ?? 5_000;
  const intervalMs = options.intervalMs ?? 150;
  const deadline = Date.now() + timeoutMs;
  let lastError: unknown;

  while (Date.now() <= deadline) {
    try {
      const session = await getSessionFn();
      if (hasAuthenticatedPublicSession(session)) {
        return session;
      }
    } catch (error) {
      lastError = error;
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  throw lastError instanceof Error
    ? lastError
    : new Error('Не удалось дождаться активной сессии после входа');
}
